var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
export var GearErrorCode;
(function (GearErrorCode) {
    GearErrorCode[GearErrorCode["DEVICE_LOST"] = 0] = "DEVICE_LOST";
    GearErrorCode[GearErrorCode["MISSING_APP"] = 1] = "MISSING_APP";
    GearErrorCode[GearErrorCode["DEVICE_HAS_NO_STORAGE"] = 2] = "DEVICE_HAS_NO_STORAGE";
    GearErrorCode[GearErrorCode["APP_ALREADY_USED"] = 3] = "APP_ALREADY_USED";
    GearErrorCode[GearErrorCode["NOT_ENOUGHT_SPACE"] = 5] = "NOT_ENOUGHT_SPACE";
})(GearErrorCode || (GearErrorCode = {}));
export var GearSupportedNfcChipType;
(function (GearSupportedNfcChipType) {
    GearSupportedNfcChipType["MifareClassic"] = "MifareClassic";
    GearSupportedNfcChipType["MifareClassicEV1"] = "MifareClassicEV1";
    GearSupportedNfcChipType["NTag213"] = "NTag213";
    GearSupportedNfcChipType["Unknown"] = "";
})(GearSupportedNfcChipType || (GearSupportedNfcChipType = {}));
var GearNative = /** @class */ (function (_super) {
    __extends(GearNative, _super);
    function GearNative() {
        var _this = _super.call(this) || this;
        _this.onDetected = null;
        _this.onLost = null;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    GearNative.prototype.getPrefix = function () {
        return 'gear_';
    };
    GearNative.prototype.init = function (credentials) {
        return this.addCredentials(credentials);
    };
    /**
     * Add Nfc credentials to encrypt chips
     * @param credentials array of byte[0;255]
     * @param reset remove all other credentials
     */
    GearNative.prototype.addCredentials = function (credentials, reset) {
        if (reset === void 0) { reset = false; }
        return NativeInterface.instance.request({
            name: this.getPrefix() + 'addCredentials',
            params: {
                bytes: credentials,
                reset: reset
            }
        });
    };
    GearNative.prototype.onEvent = function (event) {
        try {
            if (event.name === this.getPrefix() + 'detected') {
                //gear uid
                // alert(JSON.stringify(event));
                if (this.onDetected !== null) {
                    this.onDetected(event.params);
                }
                else
                    alert('no callback for detect');
            }
            else if (event.name === this.getPrefix() + 'lost') {
                //gear uid ?
                alert(JSON.stringify(event.params));
                if (this.onLost !== null)
                    this.onLost(event.params);
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    GearNative.prototype.readApp = function (appId, bytesToRead) {
        var self = this;
        // return new Promise<{bytes: number[]}>(function(resolve, reject){
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'readApp',
            params: {
                appId: appId,
                bytesToRead: bytesToRead
            }
        });
        // });
    };
    GearNative.prototype.writeOnGear = function (appId, bytes, position) {
        if (position === void 0) { position = 0; }
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'writeApp',
            params: {
                appId: appId,
                position: position,
                bytes: bytes,
            }
        });
    };
    GearNative.prototype.initApp = function (appId, transactional, bytes) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'initApp',
            params: {
                appId: appId,
                transactional: transactional,
                bytes: bytes,
            }
        });
    };
    GearNative.prototype.enableDetection = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'enable',
            params: {}
        });
    };
    GearNative.prototype.disableDetection = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'disable',
            params: {}
        });
    };
    GearNative.prototype.resetStorage = function (gearIdToSetIfFullEmpty) {
        if (gearIdToSetIfFullEmpty === void 0) { gearIdToSetIfFullEmpty = undefined; }
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'resetStorage',
            params: {
                chipUid: gearIdToSetIfFullEmpty
            }
        });
    };
    GearNative.prototype.setAutoInitDevice = function (status) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'setAutoInitDevice',
            params: {
                status: status
            }
        });
    };
    GearNative.prototype.setConfig = function (config) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'setConfig',
            params: config
        });
    };
    GearNative.prototype.status = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'status',
            params: {}
        });
    };
    GearNative.prototype.getLogs = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'getLogs',
            params: {}
        }).then(function (response) {
            return response.logs;
        });
    };
    return GearNative;
}(NativeModule));
export { GearNative };
//# sourceMappingURL=GearNative.js.map